import * as React from 'react'

import { Table } from '@factorialco/deprecated-design-system'

import i18n from 'modules/core/lib/i18n'

const EmptyList = () => {
  return (
    <Table.Body>
      <Table.Blank
        colSpan={14}
        text={i18n.t('documents.document_templates.all_available_variables_list.empty')}
      />
    </Table.Body>
  )
}

export default EmptyList
